import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx } from "vue";
import { patientStore } from '@/store/patient';
export default /*#__PURE__*/ _defineComponent({
    __name: 'actionButton',
    props: {
        iconname: String,
        colorbackground: {
            type: String,
            default: "#1A576E"
        }
    },
    emits: ["callAction"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var store = patientStore();
        function getTitle(iconname) {
            return (iconname === 'trash' ? 'deleteIcon' :
                iconname === 'plus' ? 'plusIcon' :
                    iconname === 'pen' ? 'penIcon' :
                        iconname === 'lock' ? 'lockIcon' :
                            iconname === 'info' ? 'infoIcon' :
                                iconname === 'eye' ? 'eyeIcon' :
                                    iconname === 'exclamation' ? 'exclemationIcon' :
                                        iconname === 'arrow-down' ? 'moveIcon' :
                                            iconname === 'up-down' ? 'moveIcon' :
                                                iconname === 'download' ? 'downloadIcon' :
                                                    iconname === 'user-doctor' ? 'previewIcon' :
                                                        iconname === 'envelope' ? 'mailIcon' :
                                                            iconname === 'location-dot' ? 'locationIcon' :
                                                                iconname === 'paperclip' ? 'attachIcon' :
                                                                    iconname === 'phone' ? 'phoneIcon' :
                                                                        iconname === 'globe' ? 'globeIcon' :
                                                                            'Titolo non disponibile');
        }
        return function (_ctx, _cache) {
            var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
            var _component_font_awesome_layers = _resolveComponent("font-awesome-layers");
            return (_openBlock(), _createBlock(_component_font_awesome_layers, {
                class: "fa-lg",
                onClick: _cache[0] || (_cache[0] = function ($event) { return (_ctx.$emit('callAction', __props.iconname)); })
            }, {
                default: _withCtx(function () { return [
                    (__props.iconname === 'trash')
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 0,
                            icon: "fa-solid fa-square",
                            style: { color: '#DF2F70' }
                        }))
                        : _createCommentVNode("", true),
                    (__props.iconname !== 'trash' && __props.iconname !== 'downloadMobileIcon')
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 1,
                            icon: "fa-solid fa-square",
                            style: _normalizeStyle({ color: __props.colorbackground })
                        }, null, 8, ["style"]))
                        : _createCommentVNode("", true),
                    _createVNode(_component_font_awesome_icon, {
                        icon: 'fa-solid fa-' + __props.iconname,
                        transform: "shrink-6",
                        style: { color: 'white' },
                        title: _ctx.$t(getTitle(__props.iconname))
                    }, null, 8, ["icon", "title"])
                ]; }),
                _: 1
            }));
        };
    }
});
